import { trackGaEvent } from "../util/gtm";

const trackClick = (evt: Event): void => {
    if (evt.currentTarget instanceof HTMLAnchorElement) {
        const href = evt.currentTarget.attributes.getNamedItem("href");
        const customerId = evt.currentTarget.dataset.customerid;
        const customerName = evt.currentTarget.dataset.customername;
        const businessId = evt.currentTarget.dataset.businessid;
        const businessName = evt.currentTarget.dataset.businessname;
        const container = evt.currentTarget.dataset.container;

        trackGaEvent("on_external_link_clicked", {
            href: href?.value,
            customer_id: customerId,
            customer_name: customerName,
            business_id: businessId,
            business_name: businessName,
            container: container
        });
    }
};

const trackKpi = (evt: Event) => {
    if (evt.target instanceof HTMLElement) {
        trackGaEvent("on_kpi", {
            action: evt.target.dataset.kpi,
            item_id: evt.target.dataset.itemid,
            in_section: evt.target.dataset.inSection,
            item_type: evt.target.dataset.itemtype,
            item_category: evt.target.dataset.itemcategory,
            variant: evt.target.dataset.variant,
            customer_name: evt.target.dataset.customername,
            customer_id: evt.target.dataset.customerid,
            business_name: evt.target.dataset.businessname,
            business_id: evt.target.dataset.businessid,
            placement: evt.target.dataset.placement,
            container: evt.target.dataset.container,
            container_variant: evt.target.dataset.containervariant,
        });
    }
};

const hookLinkTracking = (el: ParentNode) => {
    const allLinks = el.querySelectorAll('a[href*="https"],a[href*="http"]');

    allLinks.forEach((a) => {
        a.addEventListener("click", trackClick);
    });
};

const hookKpiTracking = (el: ParentNode) => {
    const elements = el.querySelectorAll<HTMLElement>(
        "a[data-kpi],a[ga-track-kpi]"
    );

    elements.forEach((element) => {
        if (element.dataset.kpi && element.dataset.kpi.length > 0) {
            element.addEventListener("click", trackKpi);
        }
    });
};

let impressionObserver: IntersectionObserver | null = null;

if ("IntersectionObserver" in window) {
    impressionObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const element = entry.target as HTMLElement;

                    const itemId = element.dataset.itemid;
                    const inSection = element.dataset.inSection;
                    const objectType = element.dataset.itemtype;
                    const itemCategory = element.dataset.itemcategory;
                    const variant = element.dataset.variant;
                    const customerName = element.dataset.customername;
                    const customerId = element.dataset.customerid;
                    const businessName = element.dataset.businessname;
                    const businessId = element.dataset.businessid;
                    const placement = element.dataset.placement;
                    const container = element.dataset.container;
                    const containerVariant = element.dataset.containervariant;

                    trackGaEvent("on_impression", {
                        item_id: itemId,
                        in_section: inSection,
                        item_type: objectType,
                        item_category: itemCategory,
                        variant: variant,
                        customer_name: customerName,
                        customer_id: customerId,
                        business_name: businessName,
                        business_id: businessId,
                        placement: placement,
                        container: container,
                        container_variant: containerVariant,
                    });

                    impressionObserver?.unobserve(element);
                }
            });
        },
        { threshold: 0.5 }
    );
}

const hookImpressionTracking = (el: ParentNode) => {
    const elements = el.querySelectorAll<HTMLElement>("[ga-track-impression]");

    elements.forEach((element) => {
        impressionObserver?.observe(element);
    });
};

export const hookDefaultGATracking = (el: ParentNode) => {
    hookLinkTracking(el);
    hookKpiTracking(el);
    hookImpressionTracking(el);
};
